import { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useThemeStore } from './state/theme';
import { useTenantStore } from './state/tenant';
import { useAuthStore } from './state/auth';
import { Layout } from './components/Layout';
import { AuthBoundary } from './components/AuthBoundary';

const Dashboard = lazy(() => import('./views/Dashboard').then((m) => ({ default: m.Dashboard })));
const TreasuryHome = lazy(() =>
  import('./views/TreasuryHome').then((m) => ({ default: m.TreasuryHome })),
);
const Configuracion = lazy(() =>
  import('./views/Configuracion').then((m) => ({ default: m.Configuracion })),
);
const ConfiguracionEmpresa = lazy(() =>
  import('./views/ConfiguracionEmpresa').then((m) => ({ default: m.ConfiguracionEmpresa })),
);
const Catalogos = lazy(() => import('./views/Catalogos').then((m) => ({ default: m.Catalogos })));
const CatalogoPaises = lazy(() =>
  import('./views/catalogos/CatalogoPaises').then((m) => ({ default: m.CatalogoPaises })),
);
const CatalogoMonedas = lazy(() =>
  import('./views/catalogos/CatalogoMonedas').then((m) => ({ default: m.CatalogoMonedas })),
);
const CatalogoBancos = lazy(() =>
  import('./views/catalogos/CatalogoBancos').then((m) => ({ default: m.CatalogoBancos })),
);
const CatalogoRubros = lazy(() =>
  import('./views/catalogos/CatalogoRubros').then((m) => ({ default: m.CatalogoRubros })),
);
const CatalogoTiposCuenta = lazy(() =>
  import('./views/catalogos/CatalogoTiposCuenta').then((m) => ({ default: m.CatalogoTiposCuenta })),
);
const CatalogoTiposMembresia = lazy(() =>
  import('./views/catalogos/CatalogoTiposMembresia').then((m) => ({
    default: m.CatalogoTiposMembresia,
  })),
);
const CatalogoTiposCuota = lazy(() =>
  import('./views/catalogos/CatalogoTiposCuota').then((m) => ({ default: m.CatalogoTiposCuota })),
);
const CatalogoCamposMiembro = lazy(() =>
  import('./views/catalogos/CatalogoCamposMiembro').then((m) => ({ default: m.CatalogoCamposMiembro })),
);
const CatalogoTiposCargoEventual = lazy(() =>
  import('./views/catalogos/CatalogoTiposCargoEventual').then((m) => ({
    default: m.CatalogoTiposCargoEventual,
  })),
);
const LogisticaClasificador = lazy(() =>
  import('./views/catalogos/LogisticaClasificador').then((m) => ({ default: m.LogisticaClasificador })),
);
const Cuentas = lazy(() => import('./views/Cuentas').then((m) => ({ default: m.Cuentas })));
const EstadoCuenta = lazy(() =>
  import('./views/EstadoCuenta').then((m) => ({ default: m.EstadoCuenta })),
);
const MonitorCuenta = lazy(() =>
  import('./views/MonitorCuenta').then((m) => ({ default: m.MonitorCuenta })),
);
const MonitorTesoreria = lazy(() =>
  import('./views/MonitorTesoreria').then((m) => ({ default: m.MonitorTesoreria })),
);
const Operaciones = lazy(() =>
  import('./views/Operaciones').then((m) => ({ default: m.Operaciones })),
);
const Logistica = lazy(() => import('./views/Logistica').then((m) => ({ default: m.Logistica })));
const LogisticsHome = lazy(() =>
  import('./views/LogisticsHome').then((m) => ({ default: m.LogisticsHome })),
);
const MembershipsHome = lazy(() =>
  import('./views/MembershipsHome').then((m) => ({ default: m.MembershipsHome })),
);
const ImportarOperaciones = lazy(() =>
  import('./views/ImportarOperaciones').then((m) => ({ default: m.ImportarOperaciones })),
);
const Personas = lazy(() => import('./views/Personas').then((m) => ({ default: m.Personas })));
const Membresias = lazy(() =>
  import('./views/Membresias').then((m) => ({ default: m.Membresias })),
);
const Cargos = lazy(() => import('./views/Cargos').then((m) => ({ default: m.Cargos })));
const Recibos = lazy(() => import('./views/Recibos').then((m) => ({ default: m.Recibos })));
const ReportesMembresiasInicio = lazy(() =>
  import('./views/ReportesMembresiasInicio').then((m) => ({ default: m.ReportesMembresiasInicio })),
);
const ReporteMembresiaAntiguedad = lazy(() =>
  import('./views/ReportesMembresias').then((m) => ({ default: m.ReporteMembresiaAntiguedad })),
);
const ReporteMembresiaAntiguedadDetalle = lazy(() =>
  import('./views/ReportesMembresias').then((m) => ({ default: m.ReporteMembresiaAntiguedadDetalle })),
);
const ReporteMembresiaProyeccion = lazy(() =>
  import('./views/ReportesMembresias').then((m) => ({ default: m.ReporteMembresiaProyeccion })),
);
const ReporteMembresiaResumen = lazy(() =>
  import('./views/ReportesMembresias').then((m) => ({ default: m.ReporteMembresiaResumen })),
);
const ReporteMembresiaDetalle = lazy(() =>
  import('./views/ReportesMembresias').then((m) => ({ default: m.ReporteMembresiaDetalle })),
);
const ReporteMembresiaCuotas = lazy(() =>
  import('./views/ReportesMembresias').then((m) => ({ default: m.ReporteMembresiaCuotas })),
);
const ReporteMembresiaCuotasPendientes = lazy(() =>
  import('./views/ReportesMembresias').then((m) => ({ default: m.ReporteMembresiaCuotasPendientes })),
);
const ReporteMembresiaCuotasHistorial = lazy(() =>
  import('./views/ReportesMembresias').then((m) => ({ default: m.ReporteMembresiaCuotasHistorial })),
);
const ImportarCuotasMembresia = lazy(() =>
  import('./views/ImportarCuotasMembresia').then((m) => ({ default: m.ImportarCuotasMembresia })),
);
const CargaMasivaCuotas = lazy(() =>
  import('./views/CargaMasivaCuotas').then((m) => ({ default: m.CargaMasivaCuotas })),
);
const Conciliaciones = lazy(() =>
  import('./views/Conciliaciones').then((m) => ({ default: m.Conciliaciones })),
);
const Proyecciones = lazy(() =>
  import('./views/Proyecciones').then((m) => ({ default: m.Proyecciones })),
);
const ReportesInicio = lazy(() =>
  import('./views/ReportesInicio').then((m) => ({ default: m.ReportesInicio })),
);
const ReporteResumen = lazy(() =>
  import('./views/Reportes').then((m) => ({ default: m.ReporteResumen })),
);
const ReporteOperaciones = lazy(() =>
  import('./views/Reportes').then((m) => ({ default: m.ReporteOperaciones })),
);
const ReportePresupuesto = lazy(() =>
  import('./views/Reportes').then((m) => ({ default: m.ReportePresupuesto })),
);
const InformeFinanciero = lazy(() =>
  import('./views/InformeFinanciero').then((m) => ({ default: m.InformeFinanciero })),
);
const Presupuestos = lazy(() =>
  import('./views/Presupuestos').then((m) => ({ default: m.Presupuestos })),
);
const PresupuestoHistorial = lazy(() =>
  import('./views/PresupuestoHistorial').then((m) => ({ default: m.PresupuestoHistorial })),
);
const Login = lazy(() => import('./views/Login').then((m) => ({ default: m.Login })));
const Landing = lazy(() => import('./views/Landing').then((m) => ({ default: m.Landing })));
const PublicSiteAdmin = lazy(() =>
  import('./views/PublicSiteAdmin').then((m) => ({ default: m.PublicSiteAdmin })),
);
const PublicSiteEditors = lazy(() =>
  import('./views/PublicSiteEditors').then((m) => ({ default: m.PublicSiteEditors })),
);
const BlogAdmin = lazy(() => import('./views/BlogAdmin').then((m) => ({ default: m.BlogAdmin })));
const BlogPostEditor = lazy(() =>
  import('./views/BlogPostEditor').then((m) => ({ default: m.BlogPostEditor })),
);
const Blog = lazy(() => import('./views/Blog').then((m) => ({ default: m.Blog })));
const BlogPost = lazy(() => import('./views/BlogPost').then((m) => ({ default: m.BlogPost })));
const NotFound = lazy(() => import('./views/NotFound').then((m) => ({ default: m.NotFound })));
const Onboarding = lazy(() =>
  import('./views/Onboarding').then((m) => ({ default: m.Onboarding })),
);
const Perfil = lazy(() => import('./views/Perfil').then((m) => ({ default: m.Perfil })));
const Usuarios = lazy(() => import('./views/Usuarios').then((m) => ({ default: m.Usuarios })));
const AcceptInvitation = lazy(() =>
  import('./views/AcceptInvitation').then((m) => ({ default: m.AcceptInvitation })),
);
const OwnershipTransferRespond = lazy(() =>
  import('./views/OwnershipTransferRespond').then((m) => ({ default: m.OwnershipTransferRespond })),
);
const DesignSystem = lazy(() =>
  import('./views/DesignSystem').then((m) => ({ default: m.DesignSystem })),
);
const Superadmin = lazy(() =>
  import('./views/Superadmin').then((m) => ({ default: m.Superadmin })),
);
const SuperadminUsuarios = lazy(() =>
  import('./views/SuperadminUsuarios').then((m) => ({ default: m.SuperadminUsuarios })),
);
const SuperadminOrganizaciones = lazy(() =>
  import('./views/SuperadminOrganizaciones').then((m) => ({ default: m.SuperadminOrganizaciones })),
);
const SuperadminPlanes = lazy(() =>
  import('./views/SuperadminPlanes').then((m) => ({ default: m.SuperadminPlanes })),
);
const SuperadminReporteComercial = lazy(() =>
  import('./views/SuperadminReporteComercial').then((m) => ({
    default: m.SuperadminReporteComercial,
  })),
);

const LoadingScreen = () => (
  <div className="loading-screen">
    <div className="loading-card">Cargando...</div>
  </div>
);

const RequireScope = ({ scope, children }: { scope: string; children: JSX.Element }) => {
  const { scopes, claims } = useTenantStore();
  const user = useAuthStore((state) => state.user);
  const loading = useAuthStore((state) => state.loading);
  const isSuperadmin = Boolean(user?.isSuperadmin || claims?.superadmin);
  if (loading) return <LoadingScreen />;
  if (isSuperadmin) return children;
  if (!scopes.includes(scope)) return <Navigate to="/tesoreria" replace />;
  return children;
};

const RequireSuperadmin = ({ children }: { children: JSX.Element }) => {
  const { claims } = useTenantStore();
  const user = useAuthStore((state) => state.user);
  const loading = useAuthStore((state) => state.loading);
  const isSuperadmin = Boolean(user?.isSuperadmin || claims?.superadmin);
  if (loading) return <LoadingScreen />;
  if (!isSuperadmin) return <Navigate to="/tesoreria" replace />;
  return children;
};

const RequireAdmin = ({ children }: { children: JSX.Element }) => {
  const { role, claims } = useTenantStore();
  const user = useAuthStore((state) => state.user);
  const loading = useAuthStore((state) => state.loading);
  const isSuperadmin = Boolean(user?.isSuperadmin || claims?.superadmin);
  if (loading) return <LoadingScreen />;
  if (role !== 'admin' && !isSuperadmin) return <Navigate to="/tesoreria" replace />;
  return children;
};

const RequireOrganizationOwner = ({ children }: { children: JSX.Element }) => {
  const { activeOrganizationId, claims, organizations } = useTenantStore();
  const user = useAuthStore((state) => state.user);
  const loading = useAuthStore((state) => state.loading);
  const isSuperadmin = Boolean(user?.isSuperadmin || claims?.superadmin);
  const activeOrg = organizations.find((org) => org.id === activeOrganizationId);
  if (loading) return <LoadingScreen />;
  if (!isSuperadmin && !activeOrg?.is_owner) return <Navigate to="/tesoreria" replace />;
  return children;
};

const RequirePublicSiteAccess = ({ children }: { children: JSX.Element }) => {
  const { publicSiteAccess, claims } = useTenantStore();
  const user = useAuthStore((state) => state.user);
  const loading = useAuthStore((state) => state.loading);
  const isSuperadmin = Boolean(user?.isSuperadmin || claims?.superadmin);
  if (loading) return <LoadingScreen />;
  if (!isSuperadmin && !publicSiteAccess?.can_read) return <Navigate to="/tesoreria" replace />;
  return children;
};

const isLandingPreviewMode = () =>
  typeof window !== 'undefined' &&
  window.location.pathname === '/' &&
  new URLSearchParams(window.location.search).get('preview') === '1';

export default function App() {
  const { theme, applyTheme } = useThemeStore();

  useEffect(() => {
    applyTheme(theme);
  }, [theme, applyTheme]);

  // El panel de vista previa en vivo del editor de landing embebe un iframe a "/?preview=1".
  // Esa ruta NUNCA debe pasar por AuthBoundary: si el usuario tiene sesion activa, el bootstrap
  // de Firebase/sesion corriendo tambien dentro del iframe puede competir por la sesion exclusiva
  // del usuario (o disparar un signOut compartido por origen) y cerrar la sesion de la pestaña
  // principal. El preview solo necesita renderizar Landing en modo estatico (ver Landing.tsx).
  if (isLandingPreviewMode()) {
    return (
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Suspense fallback={<LoadingScreen />}>
          <Landing />
        </Suspense>
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthBoundary>
        <Suspense fallback={<LoadingScreen />}>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route element={<Layout />}>
              <Route path="/sitio-publico" element={<Navigate to="/public" replace />} />
              <Route
                path="/public"
                element={
                  <RequirePublicSiteAccess>
                    <PublicSiteAdmin />
                  </RequirePublicSiteAccess>
                }
              />
              <Route
                path="/public/editores"
                element={
                  <RequirePublicSiteAccess>
                    <PublicSiteEditors />
                  </RequirePublicSiteAccess>
                }
              />
              <Route
                path="/public/blog"
                element={
                  <RequirePublicSiteAccess>
                    <BlogAdmin />
                  </RequirePublicSiteAccess>
                }
              />
              <Route
                path="/public/blog/:id"
                element={
                  <RequirePublicSiteAccess>
                    <BlogPostEditor />
                  </RequirePublicSiteAccess>
                }
              />
              <Route path="/tesoreria" element={<TreasuryHome />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route
                path="/configuracion"
                element={
                  <RequireAdmin>
                    <Configuracion />
                  </RequireAdmin>
                }
              />
              <Route
                path="/configuracion/empresa"
                element={
                  <RequireAdmin>
                    <ConfiguracionEmpresa />
                  </RequireAdmin>
                }
              />
              <Route
                path="/configuracion/empresa/firmantes"
                element={<Navigate to="/configuracion/catalogos/firmantes" replace />}
              />
              <Route
                path="/configuracion/empresa/:section"
                element={
                  <RequireAdmin>
                    <Onboarding />
                  </RequireAdmin>
                }
              />
              <Route
                path="/configuracion/usuarios"
                element={
                  <RequireAdmin>
                    <RequireOrganizationOwner>
                      <RequireScope scope="members:read">
                        <Usuarios />
                      </RequireScope>
                    </RequireOrganizationOwner>
                  </RequireAdmin>
                }
              />
              <Route
                path="/configuracion/catalogos"
                element={
                  <RequireAdmin>
                    <Catalogos />
                  </RequireAdmin>
                }
              />
              <Route
                path="/configuracion/catalogos/paises"
                element={
                  <RequireAdmin>
                    <CatalogoPaises />
                  </RequireAdmin>
                }
              />
              <Route
                path="/configuracion/catalogos/monedas"
                element={
                  <RequireAdmin>
                    <CatalogoMonedas />
                  </RequireAdmin>
                }
              />
              <Route
                path="/configuracion/catalogos/bancos"
                element={
                  <RequireAdmin>
                    <CatalogoBancos />
                  </RequireAdmin>
                }
              />
              <Route
                path="/configuracion/catalogos/rubros"
                element={
                  <RequireAdmin>
                    <CatalogoRubros />
                  </RequireAdmin>
                }
              />
              <Route
                path="/configuracion/catalogos/tipos-cuenta"
                element={
                  <RequireAdmin>
                    <CatalogoTiposCuenta />
                  </RequireAdmin>
                }
              />
              <Route
                path="/configuracion/catalogos/tipos-membresia"
                element={
                  <RequireAdmin>
                    <CatalogoTiposMembresia />
                  </RequireAdmin>
                }
              />
              <Route
                path="/configuracion/catalogos/miembro-campos-extra"
                element={
                  <RequireAdmin>
                    <CatalogoCamposMiembro />
                  </RequireAdmin>
                }
              />
              <Route
                path="/configuracion/catalogos/tipos-cuota"
                element={
                  <RequireAdmin>
                    <CatalogoTiposCuota />
                  </RequireAdmin>
                }
              />
              <Route
                path="/configuracion/catalogos/tipos-cargo-eventual"
                element={
                  <RequireAdmin>
                    <CatalogoTiposCargoEventual />
                  </RequireAdmin>
                }
              />
              <Route
                path="/configuracion/catalogos/firmantes"
                element={
                  <RequireAdmin>
                    <Onboarding />
                  </RequireAdmin>
                }
              />
              <Route
                path="/configuracion/catalogos/logistica/:section"
                element={
                  <RequireAdmin>
                    <RequireScope scope="logistics:read">
                      <Logistica />
                    </RequireScope>
                  </RequireAdmin>
                }
              />
              <Route
                path="/configuracion/catalogos/logistica-clasificadores/:classifier"
                element={
                  <RequireAdmin>
                    <RequireScope scope="logistics:read">
                      <LogisticaClasificador />
                    </RequireScope>
                  </RequireAdmin>
                }
              />
              <Route
                path="/configuracion/tasa-cambio"
                element={
                  <RequireAdmin>
                    <RequireScope scope="logistics:read">
                      <Logistica />
                    </RequireScope>
                  </RequireAdmin>
                }
              />
              <Route
                path="/configuracion/formas-pago"
                element={
                  <RequireAdmin>
                    <RequireScope scope="logistics:read">
                      <Logistica />
                    </RequireScope>
                  </RequireAdmin>
                }
              />
              <Route
                path="/catalogos"
                element={<Navigate to="/configuracion/catalogos" replace />}
              />
              <Route
                path="/catalogos/paises"
                element={<Navigate to="/configuracion/catalogos/paises" replace />}
              />
              <Route
                path="/catalogos/monedas"
                element={<Navigate to="/configuracion/catalogos/monedas" replace />}
              />
              <Route
                path="/catalogos/bancos"
                element={<Navigate to="/configuracion/catalogos/bancos" replace />}
              />
              <Route
                path="/catalogos/rubros"
                element={<Navigate to="/configuracion/catalogos/rubros" replace />}
              />
              <Route
                path="/catalogos/tipos-cuenta"
                element={<Navigate to="/configuracion/catalogos/tipos-cuenta" replace />}
              />
              <Route
                path="/catalogos/tipos-membresia"
                element={<Navigate to="/configuracion/catalogos/tipos-membresia" replace />}
              />
              <Route
                path="/catalogos/tipos-cuota"
                element={<Navigate to="/configuracion/catalogos/tipos-cuota" replace />}
              />
              <Route
                path="/catalogos/tipos-cargo-eventual"
                element={<Navigate to="/configuracion/catalogos/tipos-cargo-eventual" replace />}
              />
              <Route path="/cuentas" element={<Cuentas />} />
              <Route path="/cuentas/:id/estado" element={<EstadoCuenta />} />
              <Route path="/cuentas/:id/monitor" element={<MonitorCuenta />} />
              <Route path="/tesoreria/monitor" element={<MonitorTesoreria />} />
              <Route path="/operaciones" element={<Operaciones />} />
              <Route path="/operaciones/:tipo" element={<Operaciones />} />
              <Route
                path="/logistica"
                element={
                  <RequireScope scope="logistics:read">
                    <LogisticsHome />
                  </RequireScope>
                }
              />
              <Route
                path="/logistica/home"
                element={
                  <RequireScope scope="logistics:read">
                    <Navigate to="/logistica" replace />
                  </RequireScope>
                }
              />
              <Route
                path="/logistica/inicio"
                element={
                  <RequireScope scope="logistics:read">
                    <Navigate to="/logistica" replace />
                  </RequireScope>
                }
              />
              <Route
                path="/logistica/usuarios"
                element={<Navigate to="/configuracion/usuarios" replace />}
              />
              <Route
                path="/logistica/tipos-operacion"
                element={
                  <Navigate to="/configuracion/catalogos/logistica/tipos-operacion" replace />
                }
              />
              <Route
                path="/logistica/series-numeracion"
                element={
                  <Navigate to="/configuracion/catalogos/logistica/series-numeracion" replace />
                }
              />
              <Route
                path="/logistica/tasa-cambio"
                element={<Navigate to="/configuracion/tasa-cambio" replace />}
              />
              <Route
                path="/logistica/formas-pago"
                element={<Navigate to="/configuracion/formas-pago" replace />}
              />
              <Route
                path="/logistica/:section"
                element={
                  <RequireScope scope="logistics:read">
                    <Logistica />
                  </RequireScope>
                }
              />
              <Route
                path="/importar-operaciones"
                element={
                  <RequireScope scope="operations:write">
                    <ImportarOperaciones />
                  </RequireScope>
                }
              />
              <Route
                path="/personas"
                element={
                  <RequireScope scope="people:read">
                    <Personas />
                  </RequireScope>
                }
              />
              <Route
                path="/membresias"
                element={
                  <RequireScope scope="members:read">
                    <MembershipsHome />
                  </RequireScope>
                }
              />
              <Route
                path="/membresias/home"
                element={
                  <RequireScope scope="members:read">
                    <Navigate to="/membresias" replace />
                  </RequireScope>
                }
              />
              <Route
                path="/membresias/inicio"
                element={
                  <RequireScope scope="members:read">
                    <Navigate to="/membresias" replace />
                  </RequireScope>
                }
              />
              <Route
                path="/membresias/miembros"
                element={
                  <RequireScope scope="members:read">
                    <Membresias />
                  </RequireScope>
                }
              />
              <Route
                path="/membresias/personas"
                element={
                  <Navigate
                    to="/personas"
                    replace
                    state={{ fromModule: 'membresias' }}
                  />
                }
              />
              <Route
                path="/membresias/tipos-membresia"
                element={<Navigate to="/configuracion/catalogos/tipos-membresia" replace />}
              />
              <Route
                path="/membresias/tipos-cuota"
                element={<Navigate to="/configuracion/catalogos/tipos-cuota" replace />}
              />
              <Route path="/cargos" element={<Cargos />} />
              <Route
                path="/membresias/cargos"
                element={
                  <RequireScope scope="members:read">
                    <Cargos />
                  </RequireScope>
                }
              />
              <Route path="/recibos" element={<Recibos />} />
              <Route
                path="/membresias/recibos"
                element={
                  <RequireScope scope="members:read">
                    <Recibos />
                  </RequireScope>
                }
              />
              <Route
                path="/membresias/reportes"
                element={
                  <RequireScope scope="members:read">
                    <ReportesMembresiasInicio />
                  </RequireScope>
                }
              />
              <Route
                path="/membresias/reportes/antiguedad"
                element={
                  <RequireScope scope="members:read">
                    <ReporteMembresiaAntiguedad />
                  </RequireScope>
                }
              />
              <Route
                path="/membresias/reportes/antiguedad-detalle"
                element={
                  <RequireScope scope="members:read">
                    <ReporteMembresiaAntiguedadDetalle />
                  </RequireScope>
                }
              />
              <Route
                path="/membresias/reportes/proyeccion"
                element={
                  <RequireScope scope="members:read">
                    <ReporteMembresiaProyeccion />
                  </RequireScope>
                }
              />
              <Route
                path="/membresias/reportes/resumen"
                element={
                  <RequireScope scope="members:read">
                    <ReporteMembresiaResumen />
                  </RequireScope>
                }
              />
              <Route
                path="/membresias/reportes/detalle"
                element={
                  <RequireScope scope="members:read">
                    <ReporteMembresiaDetalle />
                  </RequireScope>
                }
              />
              <Route
                path="/membresias/reportes/cuotas"
                element={
                  <RequireScope scope="members:read">
                    <ReporteMembresiaCuotas />
                  </RequireScope>
                }
              />
              <Route
                path="/membresias/reportes/cuotas-pendientes"
                element={
                  <RequireScope scope="members:read">
                    <ReporteMembresiaCuotasPendientes />
                  </RequireScope>
                }
              />
              <Route
                path="/membresias/reportes/cuotas-historial"
                element={
                  <RequireScope scope="members:read">
                    <ReporteMembresiaCuotasHistorial />
                  </RequireScope>
                }
              />
              <Route
                path="/membresias/cuotas/importar"
                element={
                  <RequireScope scope="members:read">
                    <ImportarCuotasMembresia />
                  </RequireScope>
                }
              />
              <Route
                path="/membresias/cuotas/carga-masiva"
                element={
                  <RequireScope scope="people:write">
                    <CargaMasivaCuotas />
                  </RequireScope>
                }
              />
              <Route
                path="/conciliaciones"
                element={
                  <RequireScope scope="operations:read">
                    <Conciliaciones />
                  </RequireScope>
                }
              />
              <Route path="/proyecciones" element={<Proyecciones />} />
              <Route path="/presupuestos" element={<Presupuestos />} />
              <Route
                path="/historial-operaciones"
                element={<Navigate to="/reportes/operaciones" replace />}
              />
              <Route path="/reportes" element={<ReportesInicio />} />
              <Route path="/reportes/resumen" element={<ReporteResumen />} />
              <Route path="/reportes/operaciones" element={<ReporteOperaciones />} />
              <Route path="/reportes/presupuesto" element={<ReportePresupuesto />} />
              <Route
                path="/reportes/ejecucion-anual"
                element={<PresupuestoHistorial />}
              />
              <Route path="/informe-financiero" element={<InformeFinanciero />} />
              <Route path="/perfil" element={<Perfil />} />
              <Route path="/usuarios" element={<Navigate to="/configuracion/usuarios" replace />} />
              <Route
                path="/superadmin"
                element={
                  <RequireSuperadmin>
                    <Superadmin />
                  </RequireSuperadmin>
                }
              />
              <Route
                path="/superadmin/usuarios"
                element={
                  <RequireSuperadmin>
                    <SuperadminUsuarios />
                  </RequireSuperadmin>
                }
              />
              <Route
                path="/superadmin/organizaciones"
                element={
                  <RequireSuperadmin>
                    <SuperadminOrganizaciones />
                  </RequireSuperadmin>
                }
              />
              <Route
                path="/superadmin/design-system"
                element={
                  <RequireSuperadmin>
                    <DesignSystem />
                  </RequireSuperadmin>
                }
              />
              <Route
                path="/superadmin/planes"
                element={
                  <RequireSuperadmin>
                    <SuperadminPlanes />
                  </RequireSuperadmin>
                }
              />
              <Route
                path="/superadmin/reporte-comercial"
                element={
                  <RequireSuperadmin>
                    <SuperadminReporteComercial />
                  </RequireSuperadmin>
                }
              />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/login" element={<Login />} />
            <Route path="/invitations/accept" element={<AcceptInvitation />} />
            <Route path="/ownership-transfer/respond" element={<OwnershipTransferRespond />} />
          </Routes>
        </Suspense>
      </AuthBoundary>
    </BrowserRouter>
  );
}
